import type {TMedicine} from '@app/types';
import {Tag} from 'antd';
import {EMedicineStatus} from '@app/constants';
import {useTranslation} from 'react-i18next';
import {EyeOutlined} from '@ant-design/icons';
import type {FC} from 'react';

const MedicineTag: FC<TMedicine> = ({status}) => {
  const {t} = useTranslation();

  return (
    <>
      {status === EMedicineStatus.VISUALLY_CHECKED ? (
        <Tag color="geekblue" style={{margin: 0}}>
          <EyeOutlined /> {t('Visually checked')}
        </Tag>
      ) : status === EMedicineStatus.AUDIT_NOT_REQUIRED ? (
        <Tag color="purple" style={{margin: 0}}>
          {t('Audit not required')}
        </Tag>
      ) : null}
    </>
  );
};

export default MedicineTag;
